import { render, staticRenderFns } from "./list-header.vue?vue&type=template&id=8f9284c0"
import script from "./list-header.vue?vue&type=script&lang=js"
export * from "./list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports